import { Bell, Zap, Database, Brain } from "lucide-react";
import { translations } from "../../i18n";

type Translation = (typeof translations)["de"];

function Benefits({
  isVisible,
  t,
}: {
  isVisible: (id: string) => boolean;
  t: Translation["benefits"];
}) {
  const benefitIcons = [Bell, Zap, Database, Brain];

  return (
    <section
      id="benefits"
      data-animate
      className={`py-16 sm:py-24 md:py-32 bg-slate-900/30 transition-all duration-1000 ${
        isVisible("benefits")
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-10"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-10 sm:mb-14 md:mb-20">
          {t.heading}
        </h2>

        <div className="grid md:grid-cols-2 gap-5 sm:gap-6 md:gap-8">
          {t.items.map((benefit, idx) => {
            const Icon = benefitIcons[idx];
            return (
            <div
              key={benefit.title}
              className="p-6 sm:p-8 md:p-10 bg-slate-800/50 border border-slate-700 rounded-2xl hover:border-orange-500/50 transition-all hover:scale-105 group cursor-pointer hover:shadow-2xl hover:shadow-orange-500/10"
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              {Icon ? (
                <Icon className="w-10 h-10 sm:w-12 sm:h-12 text-orange-500 mb-4 sm:mb-6 group-hover:scale-110 group-hover:rotate-6 transition-all" />
              ) : null}
              <h3 className="text-xl sm:text-2xl font-semibold mb-2 sm:mb-3 group-hover:text-orange-500 transition-colors">
                {benefit.title}
              </h3>
              <p className="text-slate-400 text-base sm:text-lg group-hover:text-slate-300 transition-colors">
                {benefit.desc}
              </p>
            </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Benefits;